export var ResultCode;
(function (ResultCode) {
    ResultCode[ResultCode["Success"] = 1] = "Success";
    ResultCode[ResultCode["Failure"] = 2] = "Failure";
    ResultCode[ResultCode["NoDeleteNeeded"] = 3] = "NoDeleteNeeded";
    ResultCode[ResultCode["NoSaveNeeded"] = 4] = "NoSaveNeeded";
})(ResultCode || (ResultCode = {}));
